import React, { Component } from 'react';
import viewHelper from '../../helpers/view';
import ProfileInfo from './profileInfo';
import MemberInfo from '../shared/memberInfo';

export default class Profile extends Component {

	render () {
		const { member } = this.props;
		return (
			<div className="container content">
				<MemberInfo title={viewHelper.getFullName(member)} subtitle={`Member No: ${member.member_no}`} />
				<div className="col-md-2 col-xs-12 col-lg-2 text-center">
					<img alt="" src={member.profile_image_url} className="img-circle profile-image"/>
				</div>
				<div className="col-md-10 col-xs-12 col-lg-10 profile-info mb-15">
					<div className="col-md-6 col-lg-6 col-xs-12 no-padding">
						<ProfileInfo title='Phone Number' icon='fas fa-mobile-alt'     info={viewHelper.getFormattedPrimaryPhone(member)} />
						<ProfileInfo title='Address'      icon="fas fa-map-marker"     info={viewHelper.getFormattedAddress(member)} />
						<ProfileInfo title='Email'        icon="far fa-envelope"       info={member.email} />
						<ProfileInfo title='Birthday'     icon="fas fa-birthday-cake"  info={viewHelper.getBirthday(member)} />
						<ProfileInfo title='Location'     icon="fas fa-location-arrow" info={member.site_name} />
					</div>
					<div className="col-md-6 col-lg-6 col-xs-12 no-padding">
						<ProfileInfo title='Barcode'         icon="fas fa-barcode"  info={member.barcode_no} />
						<ProfileInfo title='Membership Type' icon="fas fa-tag"      info={member.membership_type} />
						<ProfileInfo title='Trainer'         icon="fas fa-dumbbell" info={member.trainer} />
					</div>
				</div>

				{ member.qr_code && <div className='col-md-12 col-lg-12 text-center'>
					<div className='w-50'>
						<img src={member.qr_code} alt='QrCode' />
					</div>
				</div> }
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/components/members/profile.js